import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const message = '404 Page Not Found'

return { __sfc: true,message }
}

})